import { useEffect } from "react";

import { useTranslation } from "react-i18next";

import { cn } from "utils/cn";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "components/AlertDialog";

import { ReactComponent as Pause } from "assets/pause.svg";

import { type SessionStopDialogProps } from "./SessionStopDialog.types";

export default function SessionStopDialog({ stopRecording, open, setOpen }: SessionStopDialogProps) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) {
      document.body.style.pointerEvents = "auto";
    }
    return () => {
      document.body.style.pointerEvents = "auto";
    };
  }, [open]);

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div
            className={cn(
              "w-20 h-20 m-auto mb-5 rounded-full flex items-center justify-center bg-general-gray-200 border border-general-gray-400",
            )}
          >
            <Pause className="w-16 h-16 fill-general-gray-500" />
          </div>
          <AlertDialogTitle className="text-center">{t("session.sessionStopDialog.title")}</AlertDialogTitle>
          <AlertDialogDescription>{t("session.sessionStopDialog.description")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="w-full md:flex-1">{t("button.continue")}</AlertDialogCancel>
          <AlertDialogAction className="w-full md:flex-1" onClick={stopRecording}>
            {t("button.pause")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
